module.exports = __webpack_public_path__ + "d7ee594779c50b4e5e058896db25e757.png";